import {useMutation} from '@tanstack/react-query';
import {CoreError, UnlockResponse} from '@guestapp/sdk';
import {useChekinSDK} from 'context/ChekinSDK';

type UseUnlockDoorProps = {
  onSuccess?: (data: UnlockResponse) => void;
  onError?: (error: CoreError) => void;
};

function useUnlockDoor({onSuccess, onError}: UseUnlockDoorProps) {
  const {unlockDoor} = useChekinSDK();

  return useMutation<UnlockResponse, CoreError, string>(
    (token: string) => unlockDoor(`token=${token}`),
    {
      onSuccess,
      onError,
    },
  );
}

export {useUnlockDoor};
